$(function () {
    const textBlocks = document.querySelectorAll('.js-text-block');
    const maxHeight = 100;

    textBlocks.forEach(el => {
        if (el.clientHeight > maxHeight) {
            el.classList.add('hidden-text');
            el.nextElementSibling.textContent = "Показать больше";
            el.nextElementSibling.addEventListener('click', onShowMoreClick)
        }
    })

    function onShowMoreClick(e) {
        let show = e.target.getAttribute('data-show');
        if (show === "off") {
            e.target.textContent = "Скрыть";
            e.target.previousElementSibling.classList.remove('hidden-text');
            e.target.setAttribute('data-show', 'on');
        } else {
            e.target.previousElementSibling.classList.add('hidden-text');
            e.target.textContent = "Показать больше";
            e.target.setAttribute('data-show', 'off');
        }

    }


})
